<script setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import {useNavigationStore} from "../stores/navigation";
    import { storeToRefs } from "pinia";
    import {usePageLoadingStore} from "../stores/pageLoading";
    const { isAdminView, isMobileMenuView } = storeToRefs(useNavigationStore());
    import Loading from 'vue3-loading-overlay';
    import Header from '../layouts/Header.vue'
    import Footer from '../layouts/Footer.vue'
    import SNBAdmin from './nav/SNBAdmin.vue';
    import SNBPartAdmin from './nav/SNBPartAdmin.vue';
    import SNBSysAdmin from './nav/SNBSysAdmin.vue';

    const route = useRoute();
    const pageLoadingStore = usePageLoadingStore();

    const isLoading = computed(()=>{
        return pageLoadingStore.loading;
    });

    const isFullScreen = computed(()=>{
        return route.meta.fullScreen !== undefined && route.meta.fullScreen;
    });

    const isAdminPath = computed(() => route.path.startsWith("/admin"));
    const isPartAdminPath = computed(() => route.path.startsWith("/partadmin"));
    const isSysAdminPath = computed(() => route.path.startsWith("/sysadmin"));
</script>

<template>
    <div class="wrap" :class="{'admin-wrap':isAdminView}"> <!-- admin-wrap -->
        <Header v-if="!isFullScreen"/>
        <div class="vld-parent" :style="{'display': isMobileMenuView?'none':'block'}">
            <loading
                :active="isLoading"
                loader="dots"
                color="#3843AF"
                opacity="0.26"
                width="35"
                :is-full-page="false"></loading>
            <!-- s: 관리자 화면 레이아웃 -->
            <div class="container" v-if="isAdminPath || isPartAdminPath || isSysAdminPath">
                <div class="flex-wrap admin">
                    <SNBPartAdmin v-if="isPartAdminPath" class="snb" />
                    <SNBSysAdmin v-else-if="isSysAdminPath" class="snb" />
                    <SNBAdmin v-else="isAdminPath" class="snb" />
                    <slot/>
                </div>
            </div>
            <!-- e: 관리자 화면 레이아웃 -->
            <!-- s: 사용자 화면 레이아웃 -->
            <slot v-else />            
            <!-- e: 사용자 화면 레이아웃 -->
        </div>
    </div>
    <Footer v-if="!isFullScreen" />
</template>


<style lang="scss">
    @import '../assets/scss/common';
    @import '../assets/scss/admin';
    @import '../assets/scss/ckeditor';

</style>